export default "__VITE_ASSET__CNpylF_X__"